(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alto-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__facilAboutReveal) return;
  window.__facilAboutReveal = true;
  var els = document.querySelectorAll('.about-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  els.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-hero"] && !Shopify.designMode) return;
  try {
    
  class AltoHeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Connexion lente ou mode « économie de données » : on ne télécharge PAS la vidéo,
      // le poster suffit. Évite d'imposer plusieurs Mo en 2G/3G ou en itinérance.
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn) {
        var eff = conn.effectiveType || '';
        if (conn.saveData === true || eff === 'slow-2g' || eff === '2g') return;
      }

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var raw = isMobile ? this.dataset.mobile : this.dataset.desktop;
      var sources = [];
      try {
        sources = JSON.parse(raw || '[]');
      } catch (e) {
        sources = [];
      }
      // Mobile sans clip dédié → on reste sur le poster (perf), pas de vidéo.
      if (!sources.length) return;

      // QUALITÉ 1 : on ÉCARTE le flux HLS (application/x-mpegURL). Il est adaptatif : il démarre
      // en basse définition (480p) et ne remonte pas sur une boucle muette courte → vidéo floue
      // alors que le fichier source fait 1920. On force le MP4 progressif, pleine définition.
      var mp4 = sources.filter(function (s) { return /mp4/i.test(s.type || ''); });
      if (mp4.length) sources = mp4;
      // QUALITÉ 2 : puis on trie de la plus grande à la plus petite largeur (le navigateur
      // retient la première source lisible → il prend la meilleure définition).
      sources.sort(function (a, b) { return (b.w || 0) - (a.w || 0); });

      var self = this;
      var load = function () {
        sources.forEach(function (src) {
          var el = document.createElement('source');
          el.src = src.src;
          el.type = src.type;
          self.video.appendChild(el);
        });
        // Mode « auto » : le cadre épouse le format NATIF de la vidéo → aucun rognage.
        // L'écouteur est posé AVANT load() : sinon, sur une vidéo déjà en cache, l'événement
        // « loadedmetadata » part avant qu'on écoute et le cadre reste au format par défaut.
        var applyRatio = function () {
          var host = self.closest('.alto-hero');
          if (!host || host.getAttribute('data-hero-ratio') !== 'auto') return;
          var vw = self.video.videoWidth;
          var vh = self.video.videoHeight;
          if (!vw || !vh) return;
          var prop = window.matchMedia('(max-width: 749px)').matches ? '--hero-ratio-m' : '--hero-ratio';
          host.style.setProperty(prop, vw + ' / ' + vh);
        };
        self.video.addEventListener('loadedmetadata', applyRatio);
        // Le seuil mobile/desktop peut basculer au redimensionnement → on re-applique.
        window.addEventListener('resize', applyRatio);

        self.video.load();
        if (self.video.readyState >= 1) applyRatio(); // métadonnées déjà disponibles

        self.video.addEventListener(
          'canplay',
          function () {
            self.video.classList.add('is-loaded');
            var p = self.video.play();
            if (p && p.catch) p.catch(function () {});
          },
          { once: true }
        );
      };

      if (document.readyState === 'complete') {
        load();
      } else {
        window.addEventListener('load', load, { once: true });
      }
    }
  }

  if (!customElements.get('alto-hero-video')) {
    customElements.define('alto-hero-video', AltoHeroVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-pose"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var videos = document.querySelectorAll('.facil-pose__video');
  if (!videos.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; /* accessibilité : on laisse le poster, pas d'auto-play */

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(videos, function (v) { v.play().catch(function () {}); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { v.play().catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 });
  Array.prototype.forEach.call(videos, function (v) { io.observe(v); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-reviews-ticker"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('facil-rev-ticker')) return;

  class FacilRevTicker extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('.facil-rev__item'));
      this.n = this.items.length;
      if (this.n < 2) return;

      this.i = 0;
      this.timer = null;
      this.visible = false;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;
      if (this.reduce) return; /* accessibilité : on laisse le premier avis, pas de défilement */

      var self = this;

      /* Ne tourne QUE si le bandeau est réellement à l'écran (perf + on ne rate rien). */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            self.visible = e.isIntersecting;
            self.visible ? self.play() : self.pause();
          });
        }, { threshold: 0.2 });
        io.observe(this);
      } else {
        this.visible = true;
        this.play();
      }
    }

    disconnectedCallback() { this.pause(); }

    play() {
      if (this.timer) return;
      var self = this;
      this.timer = setInterval(function () { self.next(); }, this.interval);
    }

    pause() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      this.items[this.i].classList.remove('is-active');
      this.i = (this.i + 1) % this.n;
      this.items[this.i].classList.add('is-active');
    }
  }

  customElements.define('facil-rev-ticker', FacilRevTicker);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alto-ugc"] && !Shopify.designMode) return;
  try {
    
  class AltoUgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.alto-ugc__track');
      if (!this.track) return;
      this.videos = Array.prototype.slice.call(this.querySelectorAll('.alto-ugc__video'));
      this.setupPlayback();
      this.setupArrows();
      this.setupKeyboard();
      this.setupSound();
    }

    setupPlayback() {
      var videos = this.videos;
      if (!videos.length) return;

      // Connexion lente ou « économie de données » : aucune vidéo n'est téléchargée,
      // on laisse les posters. Ces tuiles peuvent être nombreuses (jusqu'à 12).
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn) {
        var eff = conn.effectiveType || '';
        if (conn.saveData === true || eff === 'slow-2g' || eff === '2g') return;
      }

      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              v.play().catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      videos.forEach(function (v) { io.observe(v); });
    }

    slideStep() {
      var slide = this.track.querySelector('.alto-ugc__slide');
      return slide ? slide.getBoundingClientRect().width + 2 : 280;
    }

    setupArrows() {
      var self = this;
      var prev = this.querySelector('[data-ugc-prev]');
      var next = this.querySelector('[data-ugc-next]');
      if (prev) prev.addEventListener('click', function () { self.track.scrollBy({ left: -self.slideStep(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { self.track.scrollBy({ left: self.slideStep(), behavior: 'smooth' }); });
    }

    /* Clavier : flèches gauche/droite sur le conteneur focusable. Le geste tactile/trackpad
       reste 100 % natif (jamais intercepté). */
    setupKeyboard() {
      var self = this;
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          self.track.scrollBy({ left: self.slideStep(), behavior: 'smooth' });
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          self.track.scrollBy({ left: -self.slideStep(), behavior: 'smooth' });
        }
      });
    }

    setupSound() {
      var btns = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-sound]'));
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = btn.closest('.alto-ugc__slide');
          var v = slide && slide.querySelector('.alto-ugc__video');
          if (!v) return;
          v.muted = !v.muted;
          if (!v.muted) { v.play().catch(function () {}); }
          btn.setAttribute('aria-pressed', String(!v.muted));
          btn.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son');
          slide.classList.toggle('is-unmuted', !v.muted);
        });
      });
    }
  }

  if (!customElements.get('alto-ugc-carousel')) {
    customElements.define('alto-ugc-carousel', AltoUgcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facil-announcement"] && !Shopify.designMode) return;
  try {
    
class FacilAnnouncement extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.facil-announce__item'));
    if (this.items.length <= 1) return;
    this.index = this.items.findIndex((el) => el.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;
    this.delay = parseInt(this.getAttribute('data-interval'), 10) || 3000;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const prev = this.querySelector('.facil-announce__nav--prev');
    const next = this.querySelector('.facil-announce__nav--next');
    if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, 'prev'); this.restart(); });
    if (next) next.addEventListener('click', () => { this.go(this.index + 1, 'next'); this.restart(); });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop(); else this.start();
    });

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (this.reduce || this.items.length <= 1) return;
    this.stop();
    this.timer = window.setInterval(() => this.go(this.index + 1, 'next'), this.delay);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    this.start();
  }

  go(target, dir) {
    const n = this.items.length;
    const dest = ((target % n) + n) % n;
    if (dest === this.index) return;
    const down = dir === 'prev';
    const from = down ? '-10px' : '10px';
    const to = down ? '10px' : '-10px';
    const current = this.items[this.index];
    const incoming = this.items[dest];

    incoming.style.setProperty('--from', from);
    current.style.setProperty('--to', to);

    incoming.classList.remove('is-exit', 'is-active');
    incoming.classList.add('is-prep');
    void incoming.offsetWidth;
    incoming.classList.remove('is-prep');
    incoming.classList.add('is-active');

    current.classList.remove('is-active');
    current.classList.add('is-exit');

    window.setTimeout(() => { current.classList.remove('is-exit'); }, 550);
    this.index = dest;
  }
}

if (!customElements.get('facil-announcement')) {
  customElements.define('facil-announcement', FacilAnnouncement);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
